import React from 'react';

const EstimatedArrivalContext = React.createContext();

export default EstimatedArrivalContext;
